// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-responsive[data-v-7ec4b73a]{font-size:14px}.custom-select[data-v-7ec4b73a]:disabled,.form-control[data-v-7ec4b73a]:disabled{border:none;background-color:transparent;background:none}", ""]);
// Exports
module.exports = exports;
